import { args, mc } from '@mico/mico-base-common';
// import isMecaReplace from '@utils/isMecaReplace';
mc.install(args);

// const APP_NAME_MAP = {
//   contigo: 'Contigo',
//   contigoLite: 'Contigo Lite',
// };

// export const appInfo = {
//   isContigo: /Contigo(?!Lite)/i.test(navigator.userAgent),
//   isContigoLite: /ContigoLite/i.test(navigator.userAgent),
// };

export const DOMAIN_MAP = {
  contigoNet: '.syntalk.net',
};

const isIP = (str: string) => {
  const parts = (str || '').split(':')[0].split('.');
  return parts.length === 4 && parts.every((part) => /^\d+$/.test(part));
};

export const getDomain = (): string => {
  const host = document.location.host;
  const parts = host.split('.');
  if (parts.length >= 2 && !isIP(host)) {
    return '.' + parts.slice(-2).join('.');
  }
  return DOMAIN_MAP.contigoNet;
};

export const generateRule = () => {
  const appName = '{{ctg_common_app_name}}';

  // 目前 Contigo 没有 Lite 包，注释掉 Lite appName 兼容逻辑
  // if (appInfo.isContigoLite || mc.args['lite'] === '1') {
  //   appName = APP_NAME_MAP.contigoLite;
  // }
  return [
    { name: '{{appName}}', value: appName },
    // Contigo 一期不涉及，写死币价标识
    {
      name: '{{coin}}',
      // value: isMecaReplace() ? '{{ctype_currency_golden_beans_name}}' : '{{ctype_currency_coin_name}}',
      value: '{{ctg_currency_coin_name}}',
    },
    {
      name: '{{diamond}}',
      // value: isMecaReplace() ? '{{ctype_currency_crystal_name}}' : '{{ctype_currency_diamond_name}}',
      value: '{{ctg_currency_diamond_name}}',
    },
    {
      name: '{{gamecoin}}',
      // value: isMecaReplace() ? '{{ctype_currency_dobi_coin_name}}' : '{{ctype_currency_cat_coin_name}}',
      value: '{{ctg_currency_cat_coin_name}}',
    },
  ];
};
